import React, { useMemo, useState } from "react";
import "./App.css";

// Keep the online-request workflow ready for a future audience without showing it today.
const BOOKING_ENABLED = false;

const serviceGroups = [
  {
    title: "Manicure",
    mark: "hands",
    items: [
      ["Regular Manicure without Paraffin", "$20 & up"],
      ["Regular Manicure with Paraffin", "$25 & up"],
      ["Gel Manicure without Paraffin", "$30 & up"],
      ["Gel Manicure with Paraffin", "$35 & up"],
    ],
  },
  {
    title: "Pedicure",
    mark: "feet",
    items: [
      ["Regular Pedicure without Massage", "$30 & up"],
      ["Regular Pedicure with Massage", "$35 & up"],
      ["Gel Pedicure without Massage", "$43 & up"],
      ["Gel Pedicure with Massage", "$48 & up"],
      ["Deluxe Pedicure (includes paraffin wax, foot mask)", "$45 & up"],
      ["Deluxe Gel Pedicure (includes paraffin wax, foot mask)", "$58 & up"],
    ],
  },
  {
    title: "Mani-Pedi Combo",
    mark: "combo",
    items: [
      ["Basic Manicure / Basic Pedicure without Massage", "$50 & up"],
      ["Basic Manicure / Basic Pedicure with Massage", "$55 & up"],
      ["Gel Manicure / Basic Pedicure without Massage", "$60 & up"],
      ["Gel Manicure / Basic Pedicure with Massage", "$65 & up"],
      ["Gel Manicure / Gel Pedicure without Massage", "$75 & up"],
      ["Gel Manicure / Gel Pedicure with Massage", "$80 & up"],
    ],
  },
  {
    title: "Polish Change",
    mark: "polish",
    items: [
      ["Polish", "$12 & up"],
      ["French", "$17 & up"],
      ["Gel Polish", "$27 & up"],
      ["French Gel Polish", "$33 & up"],
      ["Toe Polish", "$17 & up"],
      ["Gel Toe Polish", "$27 & up"],
      ["French Toe Gel Polish", "$33 & up"],
    ],
  },
  {
    title: "Powder Dip",
    mark: "dip",
    items: [
      ["Dip Overlay", "$35 & up"],
      ["Dip with Soak Off", "$40 & up"],
      ["Dip with Tip without Soak Off", "$40 & up"],
      ["Dip with Tip with Soak Off", "$45 & up"],
      ["Add French", "$5 & up"],
      ["Dip Ombre", "$65 & up"],
      ["French Toe Gel Polish", "$33 & up"],
    ],
  },
  {
    title: "Full Set - Hands",
    mark: "brush",
    items: [
      ["Acrylics with Regular Polish", "$35 & up"],
      ["Acrylics with Gel Polish", "$45 & up"],
      ["Pink & White", "$55 & up"],
      ["Liquid Gel", "$50 & up"],
      ["Ombre Full Set", "$65 & up"],
    ],
  },
  {
    title: "Full Set - Toes",
    mark: "brush",
    items: [
      ["Regular Polish", "$50 & up"],
      ["Gel Full Set", "$65 & up"],
      ["Add French", "$5 & up"],
    ],
  },
  {
    title: "Fill-ins",
    mark: "brush",
    items: [
      ["Regular Polish Fill-in - Hands", "$25 & up"],
      ["Gel Fill-in - Hands", "$35 & up"],
      ["Pink & White Fill-in", "$40 & up"],
      ["Pink Fill-in", "$30 & up"],
      ["Add more than 2 colors for Fill-in", "$5 & up"],
      ["Regular Polish Fill-in - Toes", "$35 & up"],
      ["Gel Fill-in - Toes", "$45 & up"],
    ],
  },
  {
    title: "Other Services",
    mark: "spark",
    items: [
      ["Nail Repair", "$5 & up"],
      ["Toe Nail Repair", "$10 & up"],
      ["Nail Art", "$10 & up"],
      ["Nail Shape - coffin, almond, stiletto, etc.", "$5 & up"],
      ["Paraffin for Hands", "$5 & up"],
      ["Paraffin for Feet", "$10 & up"],
    ],
  },
  {
    title: "Kids - Hands",
    mark: "kids",
    items: [
      ["Kid Polish Change on Hand", "$8 & up"],
      ["Kid Manicure", "$15 & up"],
      ["Kid Gel Polish Change on Hand", "$20 & up"],
      ["Kid Gel Manicure", "$25 & up"],
    ],
  },
  {
    title: "Kids - Toes & Combos",
    mark: "kids",
    items: [
      ["Kid Polish Change on Toes", "$12 & up"],
      ["Kid Pedicure", "$25 & up"],
      ["Kid Gel Polish Change on Toes", "$20 & up"],
      ["Kid Gel Pedicure", "$35 & up"],
      ["Kid Basic Manicure / Basic Pedicure", "$40 & up"],
      ["Kid Gel Manicure / Basic Pedicure", "$50 & up"],
      ["Kid Gel Manicure / Gel Pedicure", "$60 & up"],
    ],
  },
];

const allServices = serviceGroups.flatMap((group) =>
  group.items.map(([name, price]) => ({ name, price, group: group.title })),
);
const technicians = ["First available", "Lynn", "Tina", "Kim"];
const times = ["9:30 AM", "10:30 AM", "11:30 AM", "1:00 PM", "2:00 PM", "3:30 PM", "5:00 PM"];

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [bookingOpen, setBookingOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [techView, setTechView] = useState(false);
  const [request, setRequest] = useState(null);
  const [status, setStatus] = useState("pending");
  const [category, setCategory] = useState("All");
  const [estimatePicker, setEstimatePicker] = useState("");
  const [estimateItems, setEstimateItems] = useState([]);
  const [tipPercent, setTipPercent] = useState(20);
  const [customTip, setCustomTip] = useState("");
  const [form, setForm] = useState({ services: [allServices[0].name], servicePicker: "", technician: "First available", date: "", time: "", name: "", phone: "", notes: "" });
  const minDate = useMemo(() => new Date().toISOString().split("T")[0], []);
  const visibleGroups = category === "All" ? serviceGroups : serviceGroups.filter((group) => group.title === category);
  const startingTotal = useMemo(() => form.services.reduce((total, serviceName) => {
    const match = allServices.find((service) => service.name === serviceName);
    return total + Number(match?.price.match(/\d+/)?.[0] || 0);
  }, 0), [form.services]);
  const estimateSubtotal = useMemo(() => estimateItems.reduce((total, item) => total + (item.price * item.quantity), 0), [estimateItems]);
  const estimateTip = customTip !== "" ? Math.max(0, Number(customTip) || 0) : estimateSubtotal * tipPercent / 100;
  const estimateTotal = estimateSubtotal + estimateTip;

  const openBooking = (service) => {
    setForm((current) => ({ ...current, services: service ? [service] : current.services }));
    setSubmitted(false);
    setBookingOpen(true);
  };
  const addService = () => {
    if (!form.servicePicker) return;
    setForm((current) => ({ ...current, services: [...current.services, current.servicePicker], servicePicker: "" }));
  };
  const addEstimateService = () => {
    if (!estimatePicker) return;
    const selected = allServices.find((service) => service.name === estimatePicker);
    if (!selected) return;
    const price = Number(selected.price.match(/\d+/)?.[0] || 0);
    setEstimateItems((current) => {
      const existing = current.find((item) => item.name === selected.name);
      return existing
        ? current.map((item) => item.name === selected.name ? { ...item, quantity: item.quantity + 1 } : item)
        : [...current, { name: selected.name, price, quantity: 1 }];
    });
    setEstimatePicker("");
  };
  const changeEstimateQuantity = (name, change) => {
    setEstimateItems((current) => current
      .map((item) => item.name === name ? { ...item, quantity: item.quantity + change } : item)
      .filter((item) => item.quantity > 0));
  };
  const submitBooking = (event) => {
    event.preventDefault();
    const newRequest = { ...form, id: `APN-${Math.floor(1000 + Math.random() * 9000)}` };
    setRequest(newRequest);
    setStatus("pending");
    setSubmitted(true);
  };

  return (
    <div className="site-shell">
      <div className="announcement">WALK-INS WELCOME · CALL (502) 429-6215 FOR AN APPOINTMENT</div>
      <header className="site-header">
        <a className="brand" href="#home" onClick={() => setMenuOpen(false)}>
          <img src="./apn-logo.png" alt="All-Pro Nails" />
        </a>
        <button className="menu-button" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">☰</button>
        <nav className={menuOpen ? "nav open" : "nav"}>
          <a href="#estimate" onClick={() => setMenuOpen(false)}>Price Calculator</a>
          <a href="#services" onClick={() => setMenuOpen(false)}>Services & Prices</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>Our Salon</a>
          <a href="#visit" onClick={() => setMenuOpen(false)}>Visit Us</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact</a>
          {BOOKING_ENABLED && <button className="link-button" onClick={() => setTechView(true)}>Team Inbox</button>}
        </nav>
        <a className="button small header-book" href="tel:+15024296215">CALL TO BOOK</a>
      </header>

      <main>
        <section className="hero" id="home">
          <div className="hero-copy">
            <span className="gold-rule"></span>
            <p className="eyebrow">LOUISVILLE’S NEIGHBORHOOD NAIL SALON</p>
            <img className="hero-logo" src="./apn-logo.png" alt="All-Pro Nails" />
            <h1>Find your next<br /><em>signature look.</em></h1>
            <p className="hero-text">Manicures, pedicures, acrylics, gel, dip, nail art, and more - with straightforward pricing and a team that knows its customers.</p>
            <div className="hero-actions">
              <a className="button" href="tel:+15024296215">CALL (502) 429-6215</a>
              <a className="text-link" href="#services">VIEW SERVICES & PRICES →</a>
            </div>
          </div>
          <div className="hero-art">
            <div className="red-block"></div>
            <div className="blue-block"></div>
            <div className="heritage-stars" aria-hidden="true">★ ★ ★</div>
            <div className="hero-art-copy"><span>LOUISVILLE, KENTUCKY</span><strong>Family-owned.<br />Louisville proud.</strong><p>More than 20 years of welcoming generations of neighbors at our Hurstbourne Parkway salon.</p><small>1255 S. HURSTBOURNE PKWY</small></div>
          </div>
        </section>

        <section className="quick-strip">
          <div><strong>20+ YEARS HERE</strong><span>A Louisville family salon</span></div>
          <div><strong>PRICES LISTED</strong><span>No guessing before you book</span></div>
          <div><strong>CALL TO BOOK</strong><span>Speak directly with our salon team</span></div>
        </section>

        <section className="estimate-section" id="estimate">
          <div className="estimate-heading">
            <p className="eyebrow">PLAN YOUR VISIT</p>
            <h2>Add up your services.</h2>
            <p>Choose services and an optional tip to see an estimated starting total. Then call us to schedule.</p>
          </div>
          <div className="estimate-card">
            <div className="estimate-picker">
              <label htmlFor="estimate-service">Choose a service</label>
              <div>
                <select id="estimate-service" value={estimatePicker} onChange={(event) => setEstimatePicker(event.target.value)}>
                  <option value="">Select a service</option>
                  {serviceGroups.map((group) => <optgroup key={group.title} label={group.title}>{group.items.map(([name, price]) => <option key={`${group.title}-${name}`} value={name}>{name} — {price}</option>)}</optgroup>)}
                </select>
                <button className="secondary-button" type="button" onClick={addEstimateService} disabled={!estimatePicker}>ADD</button>
              </div>
            </div>

            {estimateItems.length === 0 ? <p className="estimate-empty">Your estimate is empty. Add a service to begin.</p> : <div className="estimate-items">
              {estimateItems.map((item) => <div className="estimate-item" key={item.name}>
                <div><strong>{item.name}</strong><small>${item.price} & up each</small></div>
                <div className="quantity-control" aria-label={`Quantity for ${item.name}`}><button type="button" onClick={() => changeEstimateQuantity(item.name, -1)}>−</button><span>{item.quantity}</span><button type="button" onClick={() => changeEstimateQuantity(item.name, 1)}>+</button></div>
                <strong>${item.price * item.quantity}</strong>
              </div>)}
            </div>}

            <div className="tip-builder">
              <span>Add an optional tip</span>
              <div className="tip-options">
                {[0, 15, 20, 25].map((percent) => <button type="button" key={percent} className={customTip === "" && tipPercent === percent ? "active" : ""} onClick={() => { setTipPercent(percent); setCustomTip(""); }}>{percent === 0 ? "No tip" : `${percent}%`}</button>)}
                <label>Custom $<input type="number" min="0" step="1" value={customTip} onChange={(event) => setCustomTip(event.target.value)} placeholder="0" /></label>
              </div>
            </div>

            <div className="estimate-totals">
              <p><span>Starting subtotal</span><strong>${estimateSubtotal.toFixed(2)}</strong></p>
              <p><span>Tip</span><strong>${estimateTip.toFixed(2)}</strong></p>
              <p className="grand-total"><span>Estimated total</span><strong>${estimateTotal.toFixed(2)} & up</strong></p>
            </div>
            <p className="estimate-disclaimer">This is an estimate only. Final pricing may change based on length, shape, design, removal, or added service time.</p>
            <a className="button estimate-call" href="tel:+15024296215">CALL (502) 429-6215 TO BOOK</a>
          </div>
        </section>

        <section className="services-section" id="services">
          <div className="section-heading">
            <div><p className="eyebrow">SERVICE MENU</p><h2>Choose your service.</h2></div>
            <p>All listed prices are starting prices. Final pricing can vary by length, shape, design, product removal, or additional service time.</p>
          </div>
          <div className="category-scroll" aria-label="Filter service categories">
            <button className={category === "All" ? "active" : ""} onClick={() => setCategory("All")}>All Services</button>
            {serviceGroups.map((group) => <button key={group.title} className={category === group.title ? "active" : ""} onClick={() => setCategory(group.title)}>{group.title}</button>)}
          </div>
          <div className="menu-grid">
            {visibleGroups.map((group) => (
              <article className={`menu-card ${group.mark}`} key={group.title}>
                <div className="card-accent"></div>
                <h3>{group.title}</h3>
                <div className="menu-rule"><span></span></div>
                <div className="price-list">
                  {group.items.map(([name, price]) => BOOKING_ENABLED ? (
                    <button key={name} onClick={() => openBooking(name)}><span>{name}</span><strong>{price}</strong></button>
                  ) : (
                    <div className="service-row" key={name}><span>{name}</span><strong>{price}</strong></div>
                  ))}
                </div>
              </article>
            ))}
          </div>
          <p className="price-note">Questions or ready to book? Call <a href="tel:+15024296215">(502) 429-6215</a>.</p>
        </section>

        <section className="how-section" id="about">
          <div className="how-title"><p className="eyebrow">A LOUISVILLE FAMILY SALON</p><h2>Neighbors serving<br /><em>neighbors.</em></h2></div>
          <ol className="steps">
            <li><span>01</span><div><strong>Over 20 years at this location</strong><p>Generations of Louisville customers have trusted our family at Hurstbourne Parkway.</p></div></li>
            <li><span>02</span><div><strong>Call and talk with us</strong><p>We personally check our appointment book and help find a time that works.</p></div></li>
            <li><span>03</span><div><strong>Walk-ins are welcome</strong><p>Stop by the salon or call ahead at (502) 429-6215.</p></div></li>
          </ol>
        </section>

        <section className="visit-section" id="visit">
          <div className="visit-logo"><img src="./apn-logo.png" alt="" /><span>LOUISVILLE, KENTUCKY</span></div>
          <div className="visit-card">
            <p className="eyebrow">VISIT ALL-PRO NAILS</p><h2>Your next set<br />starts here.</h2>
            <div className="visit-details">
              <div><small>ADDRESS</small><p>1255 S. Hurstbourne Pkwy<br />Louisville, KY</p><a href="https://maps.google.com/?q=1255+S+Hurstbourne+Pkwy+Louisville+KY" target="_blank" rel="noreferrer">GET DIRECTIONS →</a></div>
              <div><small>PHONE</small><p><a href="tel:+15024296215">(502) 429-6215</a></p><small>HOURS</small><p>Call for today’s hours</p></div>
            </div>
            <a className="button" href="tel:+15024296215">CALL (502) 429-6215</a>
          </div>
        </section>

        <section className="contact-section" id="contact">
          <div className="contact-heading">
            <p className="eyebrow">CONTACT ALL-PRO NAILS</p>
            <h2>Need help?</h2>
            <p>For appointments, salon questions, or to report a problem with this website, call or email us.</p>
          </div>
          <div className="contact-options">
            <a className="contact-card" href="tel:+15024296215">
              <small>PHONE</small>
              <strong>(502) 429-6215</strong>
              <span>Call the salon →</span>
            </a>
            <a className="contact-card" href="mailto:hello@allpronails.com">
              <small>EMAIL</small>
              <strong>hello@allpronails.com</strong>
              <span>Email All-Pro Nails →</span>
            </a>
          </div>
          <p className="contact-note">If you are reporting a website issue, please include what page you were on and what happened.</p>
        </section>
      </main>

      <footer><img src="./apn-logo.png" alt="All-Pro Nails" /><p>© {new Date().getFullYear()} All-Pro Nails Salon · Serving Louisville for over 20 years</p>{BOOKING_ENABLED && <button className="link-button" onClick={() => setTechView(true)}>Team Sign In</button>}</footer>

      {BOOKING_ENABLED && bookingOpen && (
        <div className="modal-backdrop" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && setBookingOpen(false)}>
          <section className="modal" role="dialog" aria-modal="true" aria-labelledby="booking-title">
            <button className="modal-close" onClick={() => setBookingOpen(false)} aria-label="Close">×</button>
            {!submitted ? <>
              <img className="modal-logo" src="./apn-logo.png" alt="All-Pro Nails" />
              <p className="eyebrow">APPOINTMENT REQUEST</p><h2 id="booking-title">Tell us what works for you.</h2>
              <p className="modal-intro">This is a request, not a confirmed appointment. A salon team member will check the paper appointment book and contact you.</p>
              <form onSubmit={submitBooking}>
                <div className="service-builder">
                  <label>Add services</label>
                  <div className="service-picker-row">
                    <select aria-label="Choose another service" value={form.servicePicker} onChange={(e) => setForm({ ...form, servicePicker: e.target.value })}>
                      <option value="">Choose another service</option>
                      {serviceGroups.map((group) => <optgroup key={group.title} label={group.title}>{group.items.map(([name, price]) => <option key={`${group.title}-${name}`} value={name}>{name} - {price}</option>)}</optgroup>)}
                    </select>
                    <button className="secondary-button add-service" type="button" onClick={addService} disabled={!form.servicePicker}>ADD</button>
                  </div>
                  <div className="selected-services" aria-label="Selected services">
                    {form.services.map((serviceName, index) => {
                      const service = allServices.find((item) => item.name === serviceName);
                      return <div key={`${serviceName}-${index}`}><span><strong>{serviceName}</strong><small>{service?.price}</small></span><button type="button" onClick={() => setForm((current) => ({ ...current, services: current.services.filter((_, itemIndex) => itemIndex !== index) }))} aria-label={`Remove ${serviceName}`}>×</button></div>;
                    })}
                  </div>
                  {form.services.length === 0 && <p className="service-error">Please add at least one service.</p>}
                  <p className="starting-total"><span>Estimated starting total</span><strong>${startingTotal} & up</strong></p>
                </div>
                <label>Preferred technician<select value={form.technician} onChange={(e) => setForm({ ...form, technician: e.target.value })}>{technicians.map((tech) => <option key={tech}>{tech}</option>)}</select></label>
                <div className="field-row">
                  <label>Preferred date<input required type="date" min={minDate} value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} /></label>
                  <label>Preferred time<select required value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })}><option value="">Choose a time</option>{times.map((time) => <option key={time}>{time}</option>)}</select></label>
                </div>
                <div className="field-row">
                  <label>Your name<input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="First and last name" /></label>
                  <label>Mobile number<input required type="tel" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="(502) 555-0123" /></label>
                </div>
                <label>Anything we should know? <span className="optional">Optional</span><textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} placeholder="Removal, nail art idea, accessibility needs…" /></label>
                <label className="consent"><input required type="checkbox" /> <span>I agree to receive appointment-related texts from All-Pro Nails. Message and data rates may apply.</span></label>
                <button className="button full" type="submit" disabled={form.services.length === 0}>SEND APPOINTMENT REQUEST</button>
              </form>
            </> : <div className="success"><span>✓</span><p className="eyebrow">REQUEST SENT</p><h2>We’ll check the book.</h2><p>Your request number is <strong>{request.id}</strong>. The assigned technician receives a private app alert and optional text alert. Your appointment remains pending until the salon confirms it.</p><button className="button" onClick={() => setBookingOpen(false)}>DONE</button><button className="text-button" onClick={() => { setBookingOpen(false); setTechView(true); }}>Preview team workflow</button></div>}
          </section>
        </div>
      )}

      {BOOKING_ENABLED && techView && (
        <div className="modal-backdrop dark" role="presentation" onMouseDown={(e) => e.target === e.currentTarget && setTechView(false)}>
          <section className="team-panel" role="dialog" aria-modal="true" aria-label="Team inbox preview">
            <button className="modal-close" onClick={() => setTechView(false)} aria-label="Close">×</button>
            <div className="team-header"><div><p className="eyebrow">PRIVATE TEAM INBOX · DEMO</p><h2>Appointment requests</h2></div><span className="online">● Salon team online</span></div>
            {request ? <article className="request-card"><div className="request-top"><span className={`status ${status.replace(" ", "-")}`}>{status}</span><small>{request.id}</small></div><div className="alert-strip"><span><strong>APP</strong> Private staff alert sent</span><span><strong>TEXT</strong> Technician alert sent from salon account</span></div><h3>{request.name || "Guest"} · {request.services.length} {request.services.length === 1 ? "service" : "services"}</h3><ul className="request-services">{request.services.map((service, index) => <li key={`${service}-${index}`}>{service}</li>)}</ul><p>{request.date} at {request.time} · {request.technician}</p>{request.notes && <blockquote>“{request.notes}”</blockquote>}{status === "pending" ? <div className="request-actions"><button className="button" onClick={() => setStatus("confirmed")}>CONFIRM IN PAPER BOOK</button><button className="secondary-button" onClick={() => setStatus("declined")}>DECLINE</button><button className="secondary-button" onClick={() => setStatus("change requested")}>SUGGEST ANOTHER TIME</button></div> : <div className="confirmation-note">✓ Status updated to <strong>{status}</strong>. The customer notification would be sent from the salon account.</div>}</article> : <div className="empty-state"><span>✦</span><h3>No demo request yet</h3><p>Submit the public booking form to see how it appears to a technician.</p><button className="button" onClick={() => { setTechView(false); openBooking(); }}>CREATE A DEMO REQUEST</button></div>}
            <div className="privacy-note"><strong>No technician phone numbers exposed.</strong> Staff receive and answer requests inside their authenticated salon account.</div>
          </section>
        </div>
      )}
    </div>
  );
}

export default App;
